import { IIconProps } from '#components/icons/types';

const ResortPass = ({ size = 30, color = '#fff' }: IIconProps) => (
  <svg
    className="svg-icon"
    height={size}
    viewBox="0 0 50 50"
    width={size}
    fill={color}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.6,38.6V13.1c0-1.5-1.2-2.7-2.7-2.7H5.1c-1.5,0.1-2.7,1.3-2.7,2.7v25.5
		c0,1.5,1.2,2.7,2.7,2.7h39.8C46.4,41.3,47.6,40.1,47.6,38.6L47.6,38.6z M46.3,38.6c0,0.8-0.6,1.4-1.4,1.4H5.1
		c-0.8,0-1.4-0.6-1.4-1.4V13.1c0-0.8,0.6-1.4,1.4-1.4h39.8c0.8,0,1.4,0.6,1.4,1.4V38.6z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.6,23.2l-6.7,0.2l-1.8-4.5c0-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.3,0.1
		l-3.4,5.3l-7.3,0.6c-0.1,0-0.2,0.1-0.3,0.2c0,0.1,0,0.3,0.1,0.3l4.4,2.9l-4,6.1c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.1
		c0.1,0,0.1,0,0.2,0l7.8-5.2c1,0.1,2.1,0.2,3.1,0.5c1.1,0.3,2.2,0.7,3.3,1.2c0.1,0.1,0.3,0.1,0.4,0s0.1-0.2,0.1-0.3l-1.4-4.1
		l6.1-3.3c0.1-0.1,0.2-0.2,0.2-0.3C35.9,23.3,35.8,23.2,35.6,23.2z"
      />
    </g>
  </svg>
);

export default ResortPass;
